import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
import useGetDriverPerformance from '../../../hooks/dashboard/performance-monitoring/useGetDriverPerformance';

const DriverBioArea = () => {
  const { nin } = useParams();
  const { getDriverPerformance, loading, driverBioData } =
    useGetDriverPerformance();

  useEffect(() => {
    getDriverPerformance(nin, () => {});
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Img src={loading ? '' : driverBioData?.profileImage} />
      <TextArea>
        <FirstTextRow>
          <BoldText>{loading ? 'Loading...' : driverBioData?.name}</BoldText>
        </FirstTextRow>

        <SecondTextRow>
          <span>NIN</span>
          <VerticalLine></VerticalLine>
          <span>{nin}</span>
        </SecondTextRow>

        <ThirdTextRow>
          <ThirdTextRowGroup>
            <Stars numStars={loading ? 0 : driverBioData?.averageRating} />
            <BoldNumberText>
              {loading ? 0 : driverBioData?.averageRating}
            </BoldNumberText>
          </ThirdTextRowGroup>

          <VerticalLine></VerticalLine>

          <ThirdTextRowGroup>
            <div>Time at Company:</div>
            <BoldNumberText>
              {loading ? 0 : driverBioData?.timeAtCompany} years
            </BoldNumberText>
          </ThirdTextRowGroup>

          <VerticalLine></VerticalLine>

          <ThirdTextRowGroup>
            <div>Current Company:</div>
            <BoldNumberText>
              {loading ? 'Loading...' : driverBioData?.currentCompanyName}
            </BoldNumberText>
          </ThirdTextRowGroup>

          <VerticalLine></VerticalLine>

          <ThirdTextRowGroup>
            <div>Employment type:</div>
            {loading ? (
              'Loading...'
            ) : (
              <StatusCell
                data={{ status: driverBioData?.status }}
                statusKey='status'
                customClasses='small-border-radius'
              />
            )}
          </ThirdTextRowGroup>
        </ThirdTextRow>
      </TextArea>
    </Container>
  );
};

export default DriverBioArea;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  gap: 16px;
  /* max-width: 827px; */
  border-radius: 5px;

  gap: 24px;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  /* border: 1px solid red; */
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;
`;

const BoldText = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const FirstTextRow = styled.div`
  display: flex;
  gap: 12px;
`;

const SecondTextRow = styled.div`
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
`;

const ThirdTextRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 27px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const ThirdTextRowGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 11px;
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;

const BoldNumberText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
`;
